<template>
  <div id="layout-member" class="bg-gray-20">
    <navbar class="sticky top-0 w-full" />
    <div id="layout-member-container" class="container mx-auto relative flex gap-x-6 sm:py-10">
      <aside v-if="isSideBarShown" class="flex-none w-224px xl:w-294px">
        <member-route-list />
      </aside>
      <main class="flex-1">
        <div class="bg-white rounded">
          <slot class="page-content" />
        </div>
      </main>
    </div>

    <addendum />
  </div>
</template>

<script setup lang="ts">
import Navbar from '@/components/navbar/navbar.vue'
import Addendum from '@/components/common/addendum.vue'
import MemberRouteList from '@/components/member/member-route-list.vue'

import { useAppStore } from '@/store/app'

useSeoMeta({
  robots: 'noindex',
})

const appStore = useAppStore()

const isSideBarShown = computed(() => appStore.isDesktopScreen)
</script>

<style lang="scss" scoped>
#layout-member-container {
  min-height: var(--content-min-height);
}
</style>
